import { render, staticRenderFns } from "./Rally5Main.vue?vue&type=template&id=31486dd1&scoped=true&"
import script from "./Rally5Main.vue?vue&type=script&lang=js&"
export * from "./Rally5Main.vue?vue&type=script&lang=js&"
import style0 from "./Rally5Main.vue?vue&type=style&index=0&id=31486dd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31486dd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
